import NewWalletRequest from "../../../../components/@transactions/wallet/NewWalletRequest";
import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletRequestNewPage() {

    return (
        <NewWalletRequest
            routeType={routeTypes.admin}
        />
    )
}       